import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueMask from 'v-mask'
import VueHtmlToPaper from 'vue-html-to-paper';
import 'vuetify/dist/vuetify.css' 
import './styles/grid.css'
import i18n from "@/i18n/index"

Vue.use(VueMask);
Vue.use(VueHtmlToPaper);
Vue.config.productionTip = false 

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
